import { Component, OnInit } from "@angular/core";
import { BaseControlComponent } from "../base-control/base-control.component";
import { ContextInteractionService } from "../../services/context-interaction.service";


@Component({
    selector: "app-phone-input",
    templateUrl: "./phone-input.component.html",
    styleUrls: ["./phone-input.component.scss"],
    standalone: false
})
export class PhoneInputComponent extends BaseControlComponent implements OnInit {
    static componentName = "PhoneInputComponent";

    inputMask = "+1 (###) ###-####"; //TODO: get input mask from country - hard-coding for US/Canada for now
    _textIsSelected: boolean = false;
    _selectedTextEvent: any;

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
        super.ngOnInit();
        const data = this.getContextValue();
        if (data) {
        }
        else {
            this.contextValue = "";
        }
    }

    //we need to check it both on input and keyup, unfortunately, not doing it in both causes different problems depending on
    //which one you pick
    checkInput(event: KeyboardEvent) {
        const key = event.key;
        if (!this.validateEntry(key, event)) {
            event.preventDefault();
            return false;
        }
        else {
            //If it's a valid character, make sure we reformat it.
            let formattedValue = this.formatInput(this.contextValue, event);
            this.contextValue = formattedValue;
            super.change();
        }
       this._textIsSelected = false;
    }

    formatInput(input: string, event: any): string {
        const format = this.inputMask;
        let inputIndex = 0;
        let result = "";
        if (input && input.length > 0) {

            //For most of the special characters, they can only exist in certain spots, so if we need to add one, remove any existing ones first
            for (let f = 0; f < format.length; f++) {
                const formatChar = format[f];

                switch (formatChar) {
                case "+":
                        input = input.replace("+", "");
                case "(":
                        input = input.replace("(", "");
                    result = `${result}${formatChar}`;
                    if (input[inputIndex] === formatChar) {

                        inputIndex = inputIndex + 1;
                    }
                    break;
                    case " ":
                        //Replace the multiple occurences
                        input = input.split(" ").join("");;
                case "-":
                    input = input.replace("-", "");
                case ")":
                    input = input.replace(")", "");

                    result = `${result}${formatChar}`;
                    if (input[inputIndex] === formatChar) {
                        inputIndex = inputIndex + 1;
                    }
                    break;
                case "#":
                    input = input.replace("#", "");
                    result = `${result}${input[inputIndex]}`;
                    inputIndex = inputIndex + 1;
                    break;
                default:
                    const charAsNumber = parseInt(formatChar, 10);
                    if (isNaN(charAsNumber)) continue;
                    result = `${result}${formatChar}`;
                    if (input[inputIndex] === formatChar) {

                        inputIndex = inputIndex + 1;
                    }
                    break;
                }
                if (inputIndex >= input.length) break;
            }
        }
        return result;
    }

    phonePasted(event: any): void {
        let formattedValue: string = this.contextValue;
        const pastedText = event.clipboardData.getData("text");
        let validPastedText = "";

        for (let c = 0; c < pastedText.length; c++) {
            if (this.validateEntry(pastedText[c], false)) { //filter the pasted text for valid characters
                validPastedText = `${validPastedText}${pastedText[c]}`;
            }
        }

        let selectedTextLength = 0;
        if (this._textIsSelected) {
            //Cut out the text we've selected since they're pasting something else in.
            let startingindex: number = this._selectedTextEvent.target.selectionStart;
            let endingindex: number = this._selectedTextEvent.target.selectionEnd;
            let selectedText: string = this._selectedTextEvent.target.value.substring(startingindex, endingindex);
            selectedTextLength = selectedText.length;

            formattedValue = formattedValue.substring(0, event.target.selectionStart) + formattedValue.substring(event.target.selectionEnd);
        }
        else {
            var amountOverLength = (formattedValue.length + validPastedText.length) - this.inputMask.length;
        }

        //Check if we're over length
        var amountOverLength = (formattedValue.length - selectedTextLength + validPastedText.length) - this.inputMask.length;

        //We're over the length, trim that many characters off pasted text
        if (amountOverLength > 0) {
            validPastedText = validPastedText.substring(0, validPastedText.length - amountOverLength);
        }

        formattedValue = formattedValue.substring(0, event.target.selectionStart) + validPastedText + formattedValue.substring(event.target.selectionStart);

        formattedValue = this.formatInput(formattedValue, event);
        this.contextValue = formattedValue;
        super.change();
        event.preventDefault();
    }

    onBlur(event: any) {
        let formattedValue = this.formatInput(this.contextValue, event);
        this.contextValue = formattedValue;
        super.change();
    }

    onClick(event: any) {
        this._textIsSelected = false;
    }

    onKeyUp(event: KeyboardEvent) {
        const key = event.key;
        if (this.validateEntry(key, event)) {
            //If it's a valid character, make sure we reformat it.
            let formattedValue = this.formatInput(this.contextValue, event);
            this.contextValue = formattedValue;
            super.change();
            return true;
        }
        event.preventDefault();
        this._textIsSelected = false;
        return false;
    }

    onTextSelected(event: any) {
        this._textIsSelected = true;
        this._selectedTextEvent = event;
    }

    validateEntry(entry: string, event: any, checkAgainstContextValueLength: boolean = true) {
        if ((!checkAgainstContextValueLength || this._textIsSelected || (checkAgainstContextValueLength && this.contextValue.length < this.inputMask.length && !this._textIsSelected))) {

            //If they;re the special characters, make sure we're trying to insert them at a valid spot in the mask
            if ((entry === "-" || entry === "(" || entry === ")" || entry === "+" || entry === "." || entry === " ")
                && event.target
                && this.inputMask[event.target.selectionStart] == entry)
                return true;

            const entryAsNumber = parseInt(entry, 10);
            if (!isNaN(entryAsNumber)) {
                return true;
            }
        }
        return false;
    }
}
